
import {
  Component,
  OnInit,
  Renderer2,
  ElementRef,
  PLATFORM_ID,
  Inject,
  Input,
  ViewEncapsulation,
  QueryList,
  ViewChildren,
  ViewChild,
  OnDestroy,
  HostListener,
  AfterViewInit,
  TransferState,
  makeStateKey
} from '@angular/core';

import { SampleText } from '../../core/models/mpp.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { MktSEOService } from '../../core/services/mkt-seo.service';
import { MktSiteCatalystService } from '../../core/services/mkt-site-catalyst.service';
import { DOCUMENT, isPlatformBrowser, Location} from '@angular/common';
import { MktDynamicOfferService } from '../../core/services/mkt-dynamic-offer.service';
import { MktModalService } from '../../core/services/mkt-modal.service';
import { MktEmergencyAlertsService } from '../../core/services/mkt-emergency-alerts.service';
import { MktTaggingTransformationService } from '../../core/services/mkt-tagging-transformation.service';
import { combineLatest } from 'rxjs';
import { CdsAnnouncerService } from '@citi-gcg-173875/citi-common-ui-cds';
import { OfferUtilService } from 'src/app/common/services/offer-util.service';
import { MktContentService } from 'src/app/core/services/mkt-content.service';
import { FootnoteService } from 'src/app/common/services/footnote.service';
import { MktBrandingService } from 'src/app/common/services/mkt-branding.service';
import { MPPTemplateName } from '../../common/constants/template-name';
import { RouteValidatorService } from 'src/app/core/services/route-validator.service';
import { CommonService } from 'src/app/common/services';

const IS_PAGE_NOT_FOUND_KEY = makeStateKey('isPageNotFound');
const PRICE_DETAILS_KEY = makeStateKey<any>('priceDetails');
const CARDS_WITH_RATINGS = makeStateKey("cardsWithRatings");
const IS_BUNDLE_LOADED_KEY = makeStateKey<boolean>('isBundleLoaded');
declare const $: any;
const ADDITIONAL_INFO_PAGES = 'Additional_Info_Pages';
const ADDITIONAL_INFO_URL = 'additional-information';


@Component({
  selector: 'app-multi-products',
  templateUrl: './raf.component.html',
  styleUrls: ['./raf.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class RafComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() sampleText: SampleText;
  bannersObj: any;
  banners: any;
  public pageContentLoaded: Boolean = false;
  pricingDetails: any;
  isMobile = false;
  device;
  cardName: string;
  afcCode: string;
  cardDetails: any;
  cardDetailsObj: any;
  rafHeaderContent: any;
  browseCardsContent: any;
  allCardsContent: any;
  rafMainContent: any;
  currentCategories: any;
  cardCategoriesContent: any;
  tempHolder: any;
  tempCatList: any;
  cardsListOnCategories: any = [];
  cardListContent: any;
  seoTags: any;
  public readMore = true;
  public showMoreMobile = true;
  compareShoppingContent: any;
  widgetSlot: Array<string> = ['', '', ''];
  widgetSlotPID: Array<string> = [];
  widgetSlotURL: Array<string> = [];
  widgetSlotCardName: Array<string> = [];
  widgetSlotCardCount: Number = 0;
  first_click = false;
  cardQuantity = 0;
  v_cardName: Array<string> = [];
  v_checked: Array<boolean> = [];
  v_pid: Array<string> = [];
  v_url: Array<string> = [];
  myCookie: string;
  compareNowBtn: boolean;
  isCkcArticlesAvailable: string;
  reviewCards: any;
  featuredCards: any = [];
  ratingsReviewConfig: any;
  cardsReview: any;
  eachCardContent: any;
  reviewDetails: any = [];
  cardsWithRR: any = [];
  prlegend: string;
  prdisclaimer: string;
  siteCatalystAllPages: {};
  categoryDescription: any;
  cardDetailsContent: any;
  category: string;
  cardArtLink: any;
  pricingLink: any;
  learnMoreApplyLink: any;
  intcCode: any;
  svc_Pid: any = [];
  svc_Hkop: any = [];
  svc_IntcCode: any = [];
  v_cardCategoriesContent: any;
  allRafCards: any = [];
  hiddenCards: Array<string> = [];
  soc: string;
  rafid: string;
  rafCategory: string;
  isModalOpen: boolean;
  modalUrl: string;
  externalUrlClicked: any;
  pageNotFound: boolean;
  isRafLinkExpired: boolean = false;
  additionalInfoData:any;
  additionalInfoCardContent:any;
  cardAdditionalInfoContent:any;
  additionalInfoContent: any;
  isExpired: boolean = true;
  mPPTemplateName = MPPTemplateName;
  private routeSub: Subscription = new Subscription();
  private dynamicOfferSub: Subscription = new Subscription();
  private brandingSerSub: Subscription = new Subscription();

  @ViewChild('pageHeader') pageHeader: ElementRef;
  @ViewChildren('rafHeader') rafHeaders: QueryList<ElementRef>;
  @ViewChildren('compareCartCardArt') compareCartCardArt: QueryList<ElementRef>;
  @ViewChild('featureComponent') featureComponent;
  isBrowser: boolean;
  isBundleLoaded: boolean;


  constructor(
    private state: TransferState,
    private route: ActivatedRoute,
    private _commonService: CommonService,
    private _offerUtilService: OfferUtilService,
    private _mktContentService: MktContentService,
    private titleService: Title,
    private mktSEOService: MktSEOService,
    private renderer2: Renderer2,
    private elementRef: ElementRef,
    private mktSiteCatalystService: MktSiteCatalystService,
    private mktDynamicOfferService: MktDynamicOfferService,
    private modalService: MktModalService,
    private mktEmergencyAlerts: MktEmergencyAlertsService,
    private announcer: CdsAnnouncerService,
    private _mktTagging: MktTaggingTransformationService,
    private router: Router,
    private location: Location,
    private footnoteService: FootnoteService,
    private mktBrandingService: MktBrandingService,
    private routerValidator: RouteValidatorService,
    @Inject(PLATFORM_ID) private platformId: string,
    @Inject(DOCUMENT) private _document,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }


  ngOnInit() {
    // RAF Init
    this.pageNotFound = false;
    this.routeSub.add(combineLatest([
      this.route.params,
      this.route.queryParams
    ]).subscribe((params) => {
      this.currentCategories = "refer-a-friend-aa-advantage".replace(/\./g, '');
      this.category = params[1]['category'] || "view-all-cards";
      this.afcCode = params[1]['afc'] || "";
      this.intcCode = params[1]['intc'] || "";
      this.soc = params[1]['soc'] || "";
      this.rafid = params[1]['rafid'] || "";
      if (!!this.rafid && !!this.soc) this.loadContent();
      else
        this.router.navigateByUrl('page-not-found');

    }));
    this.dynamicOfferSub.add(this.mktDynamicOfferService.getPriceDetails().subscribe(priceDetails => {
      if (priceDetails.length === 0) return;
      this.pricingDetails = priceDetails;
      this.state.set(PRICE_DETAILS_KEY, priceDetails);
      this.getDynamicUrls();
      this.loadPriceInformation();
    }));
    this._offerUtilService.deleteRedesignPageCookie();
  }

  ngAfterViewInit(): void {
    this.getCardsWithRatings();
    if(this.isBrowser) this.mktBrandingService.hideNavigationRaf();
  }

  private async loadContent() {
    if(!this.isBrowser) return false;
    this.isRafLinkExpired = ((!!this.rafid && !!this.soc) && this._offerUtilService.isRAFJourneyDisable())
    if (this.isRafLinkExpired) {
      this.browserOnInit();
      return;
    }
    this.isBundleLoaded = true;
    this.state.set(IS_BUNDLE_LOADED_KEY, this.isBundleLoaded);
    console.log(`>>> RAF:Bundle Loaded.`);
    this.initilizeSetUp(); // CSR flow no working with out this
  }

  private async initilizeSetUp() {
    await this.commonOnInit();
    if (this.seoTags) { this.mktSEOService.setContentfulSeoTags(this.seoTags); }
    if (!this.isBrowser) return;
    this.device = this.getDeviceName();
    this.isMobile = this.device === 'M';
    this.browserOnInit();
    this.setupRafPage();
  }

  ngOnDestroy() {
    this.brandingSerSub.unsubscribe();
    this.routeSub.unsubscribe();
    this.dynamicOfferSub.unsubscribe();
    this.mktEmergencyAlerts.clean([]);
  }

  private browserOnInit() {
    // If pageNotFound, stop processing init and load pageNotFound
    this.pageNotFound = this.state.get(IS_PAGE_NOT_FOUND_KEY, null as any);
    if (this.pageNotFound) { return; }
    // Browser specific code
    this.siteCatalystAllPages = this._mktContentService.get('Multi_Product_Page', 'copy', 'sitecatalyst-all-pages', undefined);
    this.getSCInfo(this.isRafLinkExpired ? "refer-a-friend-error" : "refer-a-friend-mpp", this.siteCatalystAllPages);
    this.initTaggingTransformation();
    this.focusOnPageLoad();

  }

  focusOnPageLoad() {
    // If previous page was not RAF AND is mobile device, then focus menu
    // else focus header
    this.isMobile = this.getDeviceName() === 'M';
    if (this.isMobile) {
    }
    else {
      const si = setInterval(() => {
        const elem = this.pageHeader?.nativeElement;

        if (!elem) { return; }

        elem.blur(); // iOS fix
        setTimeout(() => elem.focus(), 100);

        clearInterval(si);
      }, 100);
    }
  }

  private getDeviceName(width = window.innerWidth): any {
    if (width < 768)
      return 'M';
    else if (width > 991)
      return 'D';
    else
      return 'T';
  }

  private commonOnInit(): Promise<void> {
    // Emptying the arrays on route change.
    return new Promise((resolve, reject) => {

      this.cardsWithRR = [];
      this.featuredCards = [];
      this.cardsListOnCategories = [];

      // Get and set emergency alerts
      this.cardDetailsObj = this._mktContentService.get('Multi_Product_Page', 'copy', this.currentCategories, undefined);
      // Try to get card categories
      this.browseCardsContent = JSON.parse(this._mktContentService.get('Multi_Product_Page', 'copy', 'browse-all-cards', undefined)['TEXT']);
      this.compareShoppingContent = JSON.parse(this._mktContentService.get('Multi_Product_Page', 'copy', 'compareShoppingCart', undefined)['TEXT']);
      this.ratingsReviewConfig = this._mktContentService.get('Branding', 'copy', 'ratings-reviews-config', undefined);
      this.siteCatalystAllPages = this._mktContentService.get('Multi_Product_Page', 'copy', 'sitecatalyst-all-pages', undefined);
      const brandingContent = this._mktContentService.get('Branding', 'copy', 'CitiAlertsJson', undefined);
      if (brandingContent && brandingContent.MPP) {
        this.mktEmergencyAlerts.addAlerts(JSON.parse(brandingContent.MPP));
      }
      this.seoTags = JSON.parse(this.cardDetailsObj['seoTags']);
      this.cardDetails = JSON.parse(this.cardDetailsObj['TEXT']);
      this.titleService.setTitle(this.cardDetails.pageTitle);
      this.featuredCards.push({ isfeaturedCardsAvailable: this.cardDetails.isfeaturedCardsAvailable });
      this.featuredCards.push(JSON.parse(this.ratingsReviewConfig['featured-cards-with-rr']));
      this.afcCode = (!this.afcCode) ? this.cardDetails.afc : this.afcCode;
      this.intcCode = (!this.intcCode) ? this.cardDetails.intc : this.intcCode;
      this.isCkcArticlesAvailable = this.cardDetails.isCkcArticlesAvailable;
      this.rafHeaderContent = this.cardDetails.rafHeaderSection;
      this.cardCategoriesContent = this.cardDetails.cardCategories;

      this.cardsReview = JSON.parse(this.ratingsReviewConfig['cards-with-rr']);
      this.prlegend = this.ratingsReviewConfig['prlegend'];
      this.prdisclaimer = this.ratingsReviewConfig['prdisclaimer'];
      this.cardListContent = {};
      this.getDynamicOffer();
      this.getAllCardData();
      const cardsWithRR = []
      for (let i = 0; i < this.cardCategoriesContent.length; i++) {
        this.tempHolder = {};
        const tempList = [];
        const tempContent: any = this.cardCategoriesContent[i];
        const cardCategory = tempContent.cardCategory;
        const length = tempContent.cardsList.length;
        for (let j = 0; j < length; j++) {
          const tempReviewDetails = {};
          this.cardDetailsContent = this._mktContentService.get('Multi_Product_Page', 'copy', tempContent.cardsList[j], undefined);
          this.eachCardContent = JSON.parse(this.cardDetailsContent['TEXT']);
          this.eachCardContent['pidPT'] = this.eachCardContent['PID'] + (this.eachCardContent['productType'] ? `_${this.eachCardContent['productType']}` : '');
          if(!this.routerValidator.isPublishedProducts([this.eachCardContent?.pidPT])){
            continue;
          }
          if (this.eachCardContent.isHidden === 'Y') {
            this.hiddenCards.push(tempContent.cardsList[j]);
            continue;
          }
          this.eachCardContent['internalCardName'] = tempContent.cardsList[j];
          if (this.cardsReview.cards.indexOf(this.eachCardContent.PID) > -1) {
            tempReviewDetails['pid'] = this.eachCardContent.PID;
            tempReviewDetails['cardName'] = this.eachCardContent.cardName;
            tempReviewDetails['internalCardName'] = tempContent.cardsList[j];
            tempReviewDetails['learnMoreLink'] = this.eachCardContent.learnMoreApplyLink;
            cardsWithRR.push(tempReviewDetails);
          }
          let cardContent = JSON.parse(this.cardDetailsContent?.['TEXT'] || '{}');
          let cardDescription = JSON.parse(this.cardDetailsContent?.[this.currentCategories] || '{}');
          let cardTemplateName = this.mPPTemplateName.TEMPLATE_1; // Set Default template

          // Show different template style based on template name assinged in Content
          const crdTemp = this.getTemplate({cardDescription, cardTemplateName, eachCardContent: cardContent});
          this.eachCardContent = crdTemp.eachCardContent;
          this.eachCardContent.cardTemplateName = crdTemp.cardTemplateName;
          this.eachCardContent.cardDescription = crdTemp.cardDescription.cardDescription;

          // turn off Feature Flag
          this.eachCardContent.featureFlag.isEnabled = this._offerUtilService.setRibbonShowHide(this.cardDetails?.turnOffFeatureFlagList || [],
            this.eachCardContent?.PID);

          tempList.push(this.eachCardContent);
        }
        this.tempHolder['category'] = cardCategory;
        this.tempHolder['cardDetails'] = tempList;
        this.cardsListOnCategories.push(this.tempHolder);
        //Add rafid and soc code on the compare card url
        if (this.rafid && this.soc && !this.compareShoppingContent.compareNowLink.includes("&soc=") && !this.compareShoppingContent.compareNowLink.includes("&rafid=")) {
          this.rafCategory = cardCategory;
          this.compareShoppingContent.compareNowLink = this.setParamsToURL(this.compareShoppingContent.compareNowLink, `category=${this.rafCategory}&intc=${this.intcCode}&afc=${this.afcCode}&rafid=${this.rafid}&soc=${this.soc}`);
        }
      }
      this.cardsWithRR = cardsWithRR;
      resolve();
      if(this.pricingDetails.length > 0) this.getDynamicUrls();
    });
  }

  getAllCardData() {
    this.allRafCards = this.cardDetails.cardCategories[0].cardsList
      .map(key => {
        let textData;
        try {
          const allRafContent = this._mktContentService.get('Multi_Product_Page', 'copy', key, undefined);
          textData = JSON.parse(allRafContent.TEXT || {});
          textData.internalCardName = allRafContent.CONTENT_ID;
        } catch (e) {
          textData = {};
        }

        if (textData.internalCardName && (textData.PID || textData.pid) && textData.cardName) {
          return {
            internalCardName: textData.internalCardName,
            pid: textData.PID || textData.pid,
            cardName: textData.cardName,
            url: textData.pdpPageLink
          };
        }
      })
      .filter(data => !!data) || [];
  }

  compareNowBtnClick(event: any) {
    const widgetPid = [];
    const currentWidgetSlot = { products: widgetPid };
    const currentWidgetSlotDetails = [];

    for (let i = 0; i < 3; i++) {
      widgetPid.push(this.widgetSlotPID[i]);
    }
    currentWidgetSlot.products.forEach(function (product) {
      currentWidgetSlotDetails.push({
        category: 'cards:acquisition',
        product_name: 'c:' + product
      });
    });
    return event;
  }

  private getCardsWithRatings() {
    const ratingsReviewConfig = this._mktContentService.get("Branding", "copy", "ratings-reviews-config", undefined);
    let { cards } = JSON.parse(ratingsReviewConfig?.["cards-with-rr"] || '{}');
    this.state.set(CARDS_WITH_RATINGS, cards);
  }

  private setupRafPage() {
    const si = setInterval(() => {
      if (this.allRafCards.length <= 0) { return; }
      clearInterval(si);
      this.readCookie();
      this.loadCheckboxes();
      this.compareShoppingBtnToggle();
      // IE patch
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        $('.ie11up').attr('style', 'margin-left: -30px');
        $('.ie11up').css({ marginLeft: '-30px' });
      }
    }, 0);
  }

  private loadCheckboxes() {
    const instance = setTimeout(() => { if (!!this.myCookie) { this.loadCheckedValues(instance); } }, 0);
  }

  private getDynamicOffer() {
    if (!this.isBrowser) return;
    this._offerUtilService
      .getAllDynamicOffer({
        pageId: 'CitiRAFNGA',
        affinityId: this.afcCode,
        category: this.rafCategory,
        screenId: this.intcCode,
        intc: this.intcCode,
        rewardProgramType: 'RAF'
      }, (message) => console.log(`>>> RAF: Pricing Load ${message}`));
  }

  private loadPriceInformation() {
    const instance = setTimeout(() => {
      this.cardsListOnCategories[0].cardDetails.map(({ pid, productType, app }) => this._offerUtilService.populateDynamicValues(pid, this.elementRef, this.renderer2, productType, app));
      clearTimeout(instance);
    }, 0);
  }

  openAdditionalInfoPage(event: MouseEvent, addInfoCardName:string, addInfoPDPContentId:string){
    this.additionalInfoData=this.getAdditionalInfoData(addInfoPDPContentId);
    this.additionalInfoData = {
      content: '',
      siteCatalyst: {},
      showCancelButton: true,
      cancelButtonText: 'Close',
      primaryButtonText: '',
      url: '',
      useDefaults: false,
      ...this.additionalInfoData
    };
    this.additionalInfoData.genericTemplateContent = this.additionalInfoData;
    const modalInstance = this.modalService.openModal(event,this.additionalInfoData, false);

    if (true) {
      const handleOnClose = () => {
        this.closeAdditionalInfoPage();
        modalCloseSub.unsubscribe();
        modalContinueSub.unsubscribe();
      };

      // Subscribe to modal close emitter
      const modalCloseSub = !!modalInstance && modalInstance.onClose.subscribe(handleOnClose.bind(this));

      // Subscribe to modal continue emitter
      const modalContinueSub = !!modalInstance && modalInstance.onContinue.subscribe(handleOnClose.bind(this));
    }

    return false;
 }

 private getAdditionalInfoData(cardName = '') {
    this.additionalInfoCardContent = this._mktContentService.get(ADDITIONAL_INFO_PAGES, 'copy', cardName, undefined);
    this.cardAdditionalInfoContent = !!this.additionalInfoCardContent && JSON.parse(this.additionalInfoCardContent.TEXT || '{}');
    return this.cardAdditionalInfoContent;
 }

 private closeAdditionalInfoPage() {
   console.log('onclose -model');
   const arr = this.router.url.split('?');
   arr[0] = arr[0].split('/').filter(part => part != ADDITIONAL_INFO_URL).join('/');
   this.location.replaceState(arr.join('?'));
 }

  private getTemplate(crdTemp:{cardDescription: any, cardTemplateName: string, eachCardContent: any}): any{
    if(crdTemp?.cardDescription && this.cardDetails && this.cardDetails?.displayTemplateName===this.mPPTemplateName.TEMPLATE_23){
      if (!!crdTemp.eachCardContent.defaultFeaturesList) {
        let featuresData = {};
        let cDesc = [];
        let featuresList = (!!crdTemp.cardDescription?.[this.mPPTemplateName.TEMPLATE_23]?.featuresList) ? crdTemp.cardDescription?.[this.mPPTemplateName.TEMPLATE_23].featuresList : crdTemp.eachCardContent.defaultFeaturesList;
        featuresList.forEach(feature => {
          feature = feature.split("-");
          if (!featuresData[feature[0]]) {
            featuresData[feature[0]] = this._mktContentService.get('Multi_Product_Page', 'copy', feature[0], undefined);
          }
          let featureData = JSON.parse(featuresData[feature[0]]?.[feature[1]] || '{}');
          if (featureData?.isActive) cDesc.push(featureData);
        });
        crdTemp.cardDescription = { cardDescription: cDesc };
        crdTemp.cardTemplateName = this.cardDetails?.displayTemplateName;
      }
      else {
        const cDesc = crdTemp?.cardDescription?.[this.mPPTemplateName.TEMPLATE_23];
        if(cDesc){
          crdTemp.cardDescription = cDesc;
          crdTemp.cardTemplateName = this.cardDetails?.displayTemplateName;
        }
      }
    }else if(this.cardDetails?.displayTemplateName===this.mPPTemplateName.TEMPLATE_1){
      const cDesc = crdTemp?.cardDescription?.[this.mPPTemplateName.TEMPLATE_1];
      if(cDesc && cDesc?.cardDescription){
        crdTemp.cardDescription = cDesc?.cardDescription;
        crdTemp.cardTemplateName = this.cardDetails?.displayTemplateName;
      }
    }else if(this.cardDetails?.displayTemplateName===this.mPPTemplateName.TEMPLATE_COLUMNDESC){
    const cDesc = crdTemp.cardDescription?.[this.mPPTemplateName.TEMPLATE_COLUMNDESC];
    if(cDesc && cDesc?.cardDescription){
      crdTemp.cardDescription = cDesc;
      crdTemp.cardTemplateName = this.cardDetails?.displayTemplateName;
    }
  }
  if(crdTemp?.eachCardContent?.showTemplate===this.mPPTemplateName.TEMPLATE_COLUMNDESC){
    crdTemp.cardTemplateName = this.mPPTemplateName.TEMPLATE_COLUMNDESC;
  }
  return crdTemp;
}

  setDynamicVal(pricing) {
    for (let i = 0; i < pricing.length; i++) {
      this.svc_Pid[i] = pricing[i].productIdentifier;
      this.svc_Hkop[i] = pricing[i].hashCode;
      this.svc_IntcCode[i] = pricing[i].offerName;
    }
    this.getDynamicUrls();
  }

  private getDynamicUrls() {
    if (this.cardsListOnCategories.length === 0) { return; }
    this.cardsListOnCategories[0].cardDetails.map(cardDetail => {
      const product = this.pricingDetails.filter(({ productIdentifier }) => (cardDetail.PID === productIdentifier))[0];
      cardDetail.pricingInfoLink = product["terms-link"];
      const intcParam = product["apply-now-button"]?.includes('intc') ? '' : `&intc=${this.intcCode}&afc=${this.afcCode}`;
      cardDetail.applyNowButton = this.setParamsToURL(product["apply-now-button"], `&rafid=${this.rafid}&soc=${this.soc}${intcParam}`);
      cardDetail.pdpPageLink = this.setParamsToURL(cardDetail.pdpPageLink.split('?')[0], `category=${this.rafCategory}&intc=${this.intcCode}&afc=${this.afcCode}&rafid=${this.rafid}&soc=${this.soc}`);
      cardDetail.learnMoreApplyLink = cardDetail.pdpPageLink;
      const instance = setTimeout(() => {
        clearTimeout(instance);
        this.footnoteService.addFootNote(this.elementRef, this.renderer2, cardDetail, this.openAdditionalInfoPage, this);
      },500);
    });
  }

  private setParamsToURL = (url, value) => {
    if (!this.isBrowser) return url;
    url = url.includes('?') ? url.replace('?', '$') : `${url}$`;
    url = `${url}${value}`.replace('$', '?');
    return url;
  };

  loadCheckedValues(instance) {
    // If no card in cart then returning otherwise selecting all occurance of selected card in cart;
    if (this.widgetSlotPID.length === 0) { clearTimeout(instance); return; }

    this.setArray();

    for (let i = 0; i < 3; i++) {
      if (!!this.widgetSlot[i]) {
        // VAC feature card checkbox
        const select_pref_checkbox = <HTMLInputElement>(
          document.getElementById(this.widgetSlotPID[i] + '-pref-chkbox')
        );
        // Category card checkbox
        const select_checkbox = <HTMLInputElement>(
          document.getElementById(this.widgetSlotPID[i] + '-chkbox')
        );
        const get_url = <HTMLInputElement>(
          document.getElementById(this.widgetSlot[i] + '-all-crd-img')
        );
        if (select_pref_checkbox) { select_pref_checkbox.checked = true; }
        if (select_checkbox) {
          select_checkbox.checked = true;
          this.widgetSlotCardName[i] = select_checkbox.getAttribute(
            'data-card'
          );
        }
        if (get_url) { this.widgetSlotURL[i] = get_url.getAttribute('href'); }
      }
    }
    clearTimeout(instance);
    return;
  }

  updateCookie() {
    this.myCookie = null;
    //  iterate throught all the 3 widgetSlot
    for (let i = 0; i < 3; i++) {
      if (!!this.widgetSlot[i]) {
        this.myCookie =
          this.myCookie +
          '|' +
          this.widgetSlot[i] +
          ':' +
          this.widgetSlotPID[i] +
          ':view-all-cards';
      }
    }
    if (this.myCookie) {
      this.myCookie = this.myCookie.replace('null|', '');
      if (this.myCookie.charAt(0) === '|') {
        this.myCookie = this.myCookie.substring(1);
      }
    }
    this._commonService.updateCookie('compareCards', this.myCookie);
    // Again get the current cookie value

    this.setWidgetCount();
  }

  readCookie() {
    const item = this._commonService.getCookie('compareCards');
    this.myCookie = item?.join('|');
    if (item?.length > 0) {
      let row: Array<string>;
      for (let i = 0; i < item.length; i++) {
        const pid = (item[i].includes(':') ? item[i].split(':')?.[1] : item[i]);
        row = item[i].split(':');
        if (!!row[0] || !!pid) {          
          if(this.routerValidator.isPublishedProducts([pid])){
            this.addCard(row[0], null, pid);
          }
        }
      }
    }

    this.setWidgetCount();
  }

  setArray() {
    let i;
    i = 0;
    let temp_cardName;

    const a1 = <HTMLCollection>this._document.getElementsByClassName('compareChkBox');
    this.cardQuantity = a1.length;
    for (i = 0; i < this.cardQuantity; i++) {
      temp_cardName = a1.item(i).id;
      temp_cardName = temp_cardName.substring(0, temp_cardName.length - 7);
      this.v_cardName[i] = temp_cardName;
      this.v_pid[i] = a1.item(i).getAttribute('value');
      this.v_checked[i] = false;
      this.v_url[i] = a1.item(i).getAttribute('data-url');

      for (let j = 0; j <= 2; j++) {
        if (this.widgetSlot[j] === temp_cardName) {
          // Match found
          this.v_checked[i] = true;
          break;
        }
      }
    }
  }

  updateArray(cardName, status) {
    for (let i = 0; i < this.cardQuantity; i++) {
      if (this.v_cardName[i] === cardName) {
        this.v_checked[i] = status;
        break;
      }
    }
  }

  setWidgetCount() {
    // Set count manually since array is always full with three items
    this.widgetSlotCardCount = this.widgetSlot.filter(a => a !== '').length;
  }

  removeCard(cur_card, setFocus: boolean = true) {
    // Removing a card when deselected
    for (let i = 0; i <= 2; i++) {
      if (this.widgetSlot[i] === cur_card) {
        // Announce removal of card
        this.announcer.announce(`${this.widgetSlotCardName[i]} removed from Compare Cart.`);

        // Update Card Array
        this.updateArray(cur_card, false);

        // match found in position i, push all the elements after i up;
        let j = i;
        for (; j < 2; j++) {
          this.widgetSlot[j] = this.widgetSlot[j + 1];
          this.widgetSlotPID[j] = this.widgetSlotPID[j + 1];
          this.widgetSlotURL[j] = this.widgetSlotURL[j + 1];
          this.widgetSlotCardName[j] = this.widgetSlotCardName[j + 1];
        }
        this.widgetSlot[j] = '';
        this.widgetSlotPID[j] = '';
        this.widgetSlotURL[j] = '';
        this.widgetSlotCardName[j] = '';
      }
    }
    this.updateCookie();
    if (setFocus) { this.setFocusAfterCardRemoval(); }
  }

  addCard(cur_card, e, cur_pid) {
    // Prevent addition of null card
    if (
      (!cur_card || cur_card === 'null' || cur_card === null) &&
      (!cur_pid || cur_pid === undefined || cur_pid === 'null' || cur_pid === null) &&
      (!e || e === 'null' || e === null)
    ) {
      return;
    }

    // Get current card count
    let len = 0;
    for (let i = 0; i < 3; i++) {
      if (!!this.widgetSlot[i]) { len++; }
    }

    // Add card if less than 3, otherwise throw error
    if (len < 3) {

      if (e) { this.widgetSlotPID[len] = e.target.value; } else { this.widgetSlotPID[len] = cur_pid; }

      // Get card content
      let cardContent = this.getCardByPid(this.widgetSlotPID[len]);
      if (!cardContent) { cardContent = this.getCardByInternalName(cur_card); }
      if (!cardContent) return;

      //Add rafid and soc code on the PDP url
      if (this.rafid && this.soc && !cardContent.url.includes("&soc=") && !cardContent.url.includes("&rafid=")) {
        cardContent.url = this.setParamsToURL(cardContent.url, `category=${this.rafCategory}&rafid=${this.rafid}&soc=${this.soc}&afc=${this.afcCode}&intc=${this.intcCode}`);
      }

      // add card if not added before
      if (!this.widgetSlot.includes(cardContent.internalCardName)) {
        this.widgetSlot[len] = cardContent.internalCardName;
        this.widgetSlotCardName[len] = cardContent.cardName;
        this.widgetSlotURL[len] = cardContent.url;
        // Update array with new card
        this.updateArray(this.widgetSlot[len], true);
      }
    } else if (len >= 3) {
      if (this.first_click) {

        // Annouce error for ada purposes
        this.announcer.announce('Three cards have already been selected and no additional cards can be added for comparison.');

        // Uncheck box
        if (e) { e.target.checked = false; }
      }
    }

    this.updateCookie();
  }

  setFocusAfterCardRemoval() {
    setTimeout(() => {
      const lastCard = this.compareCartCardArt?.last;
      if (lastCard) {
        lastCard.nativeElement?.focus();
      } else {
        this.pageHeader?.nativeElement?.focus();
      }
    }, 500);
  }

  togglecomparebuttonPref(e, url, cardName, firstClick = true) {
    this.first_click = firstClick;
    let cur_card = e.target.id;


    cur_card = cur_card.replace('-pref-chkbox', '');
    const select_checkbox = <HTMLInputElement>(
      document.getElementById(e.currentTarget.value + '-chkbox')
    );
    if (e.target.checked === false) {
      if (select_checkbox) { select_checkbox.checked = false; }
      // Get card content
      // Calling the add function if checkbox is selected/checked
      const cardPid = e.currentTarget.value;
      let cardContent = this.getCardByPid(cardPid);
      if (!cardContent) { cardContent = this.getCardByInternalName(cur_card); }
      this.removeCard(cardContent.internalCardName, false);
    } else {
      if (select_checkbox) { select_checkbox.checked = true; }
      const cardPid = e.currentTarget.value;
      this.addCard(cur_card, e, cardPid);
      if (e.target.checked === false) {
        if (select_checkbox) { select_checkbox.checked = false; }
      }
    }
    if (this.first_click) {
      this.first_click = false;
      this.togglecomparebutton(e, url, cardName, false);
      this.compareShoppingBtnToggle();
    }
  }

  compareShoppingBtnToggle() {
    let len = 0;
    for (let j = 0; j <= 2; j++) {
      if (!!this.widgetSlot[j]) {
        len++;
      }
    }
    if (len >= 2) { this.compareNowBtn = true; } else { this.compareNowBtn = false; }
  }

  togglecomparebutton(e, url, cardName, firstClick = true) {
    this.first_click = firstClick;
    let cur_card = e.target.id;
    cur_card = cur_card.replace('-chkbox', '');

    const select_pref_checkbox = <HTMLInputElement>(
      document.getElementById(e.currentTarget.value + '-pref-chkbox')
    );
    // Calling remove function if checkbox is deselected
    if (e.target.checked === false) {
      if (select_pref_checkbox) { select_pref_checkbox.checked = false; }
      const cardPid = e.currentTarget.value;
      let cardContent = this.getCardByPid(cardPid);
      if (!cardContent) { cardContent = this.getCardByInternalName(cur_card); }
      this.removeCard(cardContent.internalCardName, false);
    } else {
      // Calling the add function if checkbox is selected/checked
      const cardPid = e.currentTarget.value;
      this.addCard(cur_card, e, cardPid);
      if (select_pref_checkbox) { select_pref_checkbox.checked = e.target.checked; }
    }

    if (this.first_click) {
      this.togglecomparebuttonPref(e, url, cardName, false);
      this.compareShoppingBtnToggle();
    }
  }

  closeBtnClickKeyPress(e, i) {
    if (e.keyCode === 32 || e.keyCode === 13) { this.closeBtnClick(i); }
  }

  closeBtnClick(i) {
    this.first_click = true;
    // Deselecting the actual checkbox
    const chkbox_to_be_disabled = <HTMLInputElement>(
      document.getElementById(this.widgetSlotPID[i] + '-chkbox')
    );
    const pref_chkbox_to_be_disabled = <HTMLInputElement>(
      document.getElementById(this.widgetSlotPID[i] + '-pref-chkbox')
    );
    if (chkbox_to_be_disabled) {
      chkbox_to_be_disabled.checked = false;
    }
    if (pref_chkbox_to_be_disabled) { pref_chkbox_to_be_disabled.checked = false; }

    // Calling remove function when close button is clicked
    this.removeCard(this.widgetSlot[i]);
    this.compareShoppingBtnToggle();
  }

  openModal(url, event) {
    event.preventDefault();

    this.modalService.openModal(event, {
      url: url,
      isExternalLink: true,
    });
  }

  getCardByPid(pid: string | number): { pid: string, internalCardName: string, cardName: string, url: string } {
    if (!pid) { return; }
    return this.allRafCards.filter(card => +card.pid === +pid)[0];
  }

  getCardByInternalName(internalCardName: string): { pid: string, internalCardName: string, cardName: string, url: string } {
    if (!internalCardName) { return; }

    return this.allRafCards
      .filter(card => (card.internalCardName + '').toLocaleLowerCase() === (internalCardName + '').toLocaleLowerCase())[0];
  }

  @HostListener('window:resize', ['$event'])
  setVariableOnResize(e) {
    this.isMobile = e.target.innerWidth < 768;
    this.device = this.getDeviceName(e.target.innerWidth);
  }


  getSCInfo(urlPageName, siteCatalystAllPages) {
    if (!this.isBrowser || !window) { return; }
    const taggingIcmsContent = this._mktContentService.get(
      'Multi_Product_Page',
      'copy',
      'MPP_tagging-content',
      undefined
      );
    this.mktDynamicOfferService.setTaggingStaticIcms(taggingIcmsContent);

    this.pageContentLoaded = true;
    const SCInfo = JSON.parse(siteCatalystAllPages['SCInfo']);
    const SCPageNames = JSON.parse(siteCatalystAllPages['SCPageNames']);
    SCInfo['siteSection3'] = "special offers";
    this.mktSiteCatalystService.callSC('naAnalyticsPageView', {
      ...SCInfo,
      pageName: SCPageNames[urlPageName],
      channel: "us",
      siteSection1: "cards",
      siteSection2: "public",
      siteSection3: "special offers",
      siteSection4: "acxiom",
      pageCat: "landing page",

    });
  }

  initTaggingTransformation() {
    const copyPidArr = [];
    const tempPidArr = [];
    const tempCategoryArr = [];
    const currentCategoryPage = this.isRafLinkExpired ? "refer-a-friend-error" : "refer-a-friend-mpp";
    // set a for loop to the length of cards categories
    // currently using counting sort algorithm to sort pids by cards in specific categories
    // outer loop executes 'i' number of times based on cards in category

    for (let i = 0; i < this.cardsListOnCategories.length; i++) {
      const tempContent: any = this.cardCategoriesContent[i];
      // remove any hidden cards
      tempContent.cardsList = tempContent.cardsList.filter(card => !this.hiddenCards.includes(card));
      const length = tempContent.cardsList.length;
      const x = this.cardsListOnCategories[i];
      const y = this.cardCategoriesContent[i];
      // loop through 'i' number of cards and push PID into copyPidArr
      for (let j = 0; j < length; j++) {
        tempPidArr.push(tempContent.cardsList[j]);
        copyPidArr.push(x.cardDetails[j].PID);
        tempCategoryArr.push(y);
      }
    }
    const viewAllRAFDetails = { products: copyPidArr };
    const viewAllRAFProducts = [];

    viewAllRAFDetails.products.forEach(function (product) {
      viewAllRAFProducts.push({
        category: 'cards:acquisition',
        product_name: 'c:' + product
      });
    });

    // loop through cards category to fire the right tagging
    for (let i = 0; i < this.cardsListOnCategories.length; i++) {
      const tempContent: any = this.cardCategoriesContent[i];
      tempCategoryArr.push(tempContent.cardCategory);
    }
    const pidStrFormat = copyPidArr.toLocaleString();
    this._mktTagging.tagMktCompareCards(currentCategoryPage, { pid: pidStrFormat, products: viewAllRAFProducts });
  }
}
